import { createAction, props } from '@ngrx/store';
import {
  UserBaseAllBaseWriteUserAllUserWrite
} from '../../openapi';
import { UserDetails } from '../reducers/user-details.reducer';

export const loadUserDetails = createAction('[UserDetails] load user details');

export const loadUserDetailsSuccess = createAction(
  '[UserDetails] load user details success',
  props<{
    user: UserDetails | null
  }>()
);

export const loadUserDetailsFailure = createAction('[UserDetails] load user details failure');

export const updateUserDetails = createAction(
  '[UserDetails] update user details',
  props<{
    user: UserBaseAllBaseWriteUserAllUserWrite,
    successFnc: () => void,
    failureFnc: () => void
  }>()
);

export const updateUserDetailsSuccess = createAction(
  '[UserDetails] update user details success',
  props<{ user: UserDetails | null }>()
);

export const updateUserDetailsFailure = createAction('[UserDetails] update user details failure');
